<template>
    <div class="presentation-slide">
        <design-2021-apprentice-display-html-component
            class="simple-rte-slide"
            v-if="slideIn.type === 1"
            :html-content="slideIn.value">
        </design-2021-apprentice-display-html-component>

        <design-2021-apprentice-video-link-player-component
            class="video-slide"
            v-if="slideIn.type === 2"
            :options="playerOptions"
            :src="slideIn.value">
        </design-2021-apprentice-video-link-player-component>


        <img class="slide-image"
             v-if="slideIn.type === 5"
             :src="slideIn.file.public_path">
    </div>
</template>
<script>
export default {
    name: 'design-2021-show-slide-component',
    props: {
        slideIn: {
            required: true,
            type: Object,
        },
        slideCollection: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
            isFullscreen: false,
        };
    },
    mounted() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
    },
    beforeDestroy() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
        document.removeEventListener('keydown', this.handleKeyPres);
    },
    methods: {
        onFullscreenChange() {
            this.isFullscreen = !!document.fullscreenElement;

            if (this.isFullscreen) {
                document.addEventListener('keydown', this.handleKeyPres);
            } else {
                document.removeEventListener('keydown', this.handleKeyPres);
            }
        },

        nextSlide() {
            this.$emit('next-slide');
        },
        previousSlide() {
            this.$emit('previous-slide');
        },
        exitFullScreen() {
            this.$emit('exit-fullscreen');
        },

        handleKeyPres(event) {
            if (event.key === 'ArrowLeft') {
                this.previousSlide();
            }
            if (event.key === 'ArrowRight') {
                this.nextSlide();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.presentation-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100dvh - 52px);
    flex: 1 0 100%;
    background-color: $white;
    border: 1px solid $border-color;
    padding: map-get($grid-gutter-spacing, 'twenty-one');

    :deep(.display-html-content) {
        h2 {
            font-size: 2.0625rem;
        }

        h3 {
            font-size: 1.75rem;
        }

        h4 {
            font-size: 1.625rem;
        }

        p {
            font-size: 1.5625rem;
        }
    }
}

.simple-rte-slide,
.video-slide {
    align-self: flex-start;
    height: inherit;
    flex: 1 0;
}

.video-slide ::v-deep {
    height: 100%;

    div.video-js {
        object-fit: contain;
        height: 100%;
        padding-top: 0;
    }

    .vjs-poster {
        img {
        object-fit: contain;
        }
    }
}

.slide-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}

@media (min-width: map-get($grid-breakpoints, 'xl')){
    .presentation-slide {
        height: calc(100dvh - 149px);
        flex: 1 0 calc(100% - 230px);
    }

    .video-slide ::v-deep {
        height: 100%;

        div.video-js {
            object-fit: cover;
        }

        .vjs-poster {
            img {
                object-fit: cover;
            }
        }
    }


    .slide-image {
        width: auto;
    }
}
</style>
